import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPatronStatessById = ({ patronId }: { patronId: number }) => {
  const get = useTypedApiClient({
    path: '/admin/patron/{patronId}/states',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/patron/{patronId}/states', patronId],
    queryFn: async () => {
      const { data } = await get({ patronId: Number(patronId) })
      return data
    },
  })
}
